module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAA0UlEQVQ4jZWUOw6DMAyGPzJ2hrHtjsQlOEV7CE7DJThFL1F172MsMyuVJUdCJq9aYkhwPv3OH7visVbAEZiBhfI4AA3wdsAJeOnXFSI6zX+KAIF8VUUN3ApAnebVem52WkJfCLKAfm1ZnP68F4B2AD2H2ySlQFGAhcRAlxRAQizO1e4jCFjbvZKtosHsDRYQK2erZDR7Y8y1EMRe4jVnv4WEXJhy9rsMwN9B8h25AoCPKEgslm6UZkoBUiWfRYksSgEhRY2fJzIOpJv/nSc18PkBBhtXWjTmPRYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/health/windows_close.png
// module id = +r2w
// module chunks = 4